<template>
  <div>
    <div v-if="loading_chord" class="animate-pulse">
      <div class="mb-2">
        <div class="w-1/5 h-3 bg-gray-200 dark:bg-gray-700 mb-2"></div>
        <div class="w-full h-3 bg-gray-200 dark:bg-gray-700"></div>
      </div>
      <div class="mb-2">
        <div class="w-1/12 h-3 bg-gray-200 dark:bg-gray-700 mb-2"></div>
        <div class="w-full h-3 bg-gray-200 dark:bg-gray-700"></div>
      </div>
      <div class="mb-2">
        <div class="w-1/6 h-3 bg-gray-200 dark:bg-gray-700 mb-2"></div>
        <div class="w-full h-3 bg-gray-200 dark:bg-gray-700"></div>
      </div>
    </div>
    <div
      v-else-if="!loading_chord && !show_empty_message"
      class="flex justify-center"
    >
      <ChordDiagram
        :summary="summary"
        @showEmptyMessage="show_empty_message = true"
      />
    </div>
    <div v-else class="flex justify-center">
      <img src="/static/D3ChordEmpty.png" class="empty-message-size" />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import createChordDiagram from 'features/onlineRoundtables/services/dataVisualization/createChordDiagram';
  import createChordDiagramPublic from 'features/onlineRoundtables/services/dataVisualization/createChordDiagramPublic';
  import { mapGetters } from 'vuex';
  import URLPath from 'services/apiConfigs';

  export default Vue.extend({
    components: {
      ChordDiagram: () =>
        import('components/dataVisualization/d3js/chordDiagram.vue'),
    },
    data() {
      return {
        summary: [],
        show_empty_message: false,
        loading_chord: Boolean,
        loading_page: true,
        show_info: false,
      };
    },
    computed: {
      ...mapGetters(['getCurrentRT', 'hasTeacherPermissionsInCourse']),
      sharing_url() {
        const roundtableID = this.$route.params.roundtableID;
        return `${URLPath.apiURL}/api/roundtables/${roundtableID}/chord`;
      },
    },
    methods: {
      toParlaySite() {
        window.open('https://parlayideas.com/');
      },
      toBlogPost() {
        window.open(
          'https://parlayideas.com/revolutionize-discussion-become-a-parlay-trailblazer/'
        );
      },
      shareOnTW() {
        const rtTitle = this.getCurrentRT.title;
        const url = this.formatParam(this.sharing_url);
        const text = this.formatParam(
          `Check out this Comment Chord from our class discussion "${rtTitle}" on @parlayideas`
        );
        window.open(
          `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
          '',
          'scrollbars=yes,width=650,height=280'
        );
      },
      formatParam(param) {
        return param
          .replace(/%/g, '%25')
          .replace(/ /g, '%20')
          .replace(/\$/g, '%24')
          .replace(/#/g, '%23');
      },
    },
    created() {
      // Facebook Init
      // (function (d, s, id) {
      //   var js,
      //     fjs = d.getElementsByTagName(s)[0];
      //   if (d.getElementById(id)) {
      //     return;
      //   }
      //   js = d.createElement(s);
      //   js.id = id;
      //   js.src = 'https://connect.facebook.net/en_US/sdk.js';
      //   fjs.parentNode.insertBefore(js, fjs);
      // })(document, 'script', 'facebook-jssdk');
    },
    mounted() {
      if (this.$route.name === 'walkthrough.feed') {
        this.loading_chord === true;
        createChordDiagramPublic('e7b41d42-b980-4ee2-aff4-b6dfea324ecf')
          .then((response) => {
            response.data.d3information.splice(10, 1);
            this.summary = response.data.d3information;
            this.loading_chord = false;
            this.loading_page = false;
          })
          .catch(console.error);
      } else {
        this.loading_chord === true;
        createChordDiagram(this.$route.params.roundtableID)
          .then((response) => {
            if(this.$route.params.roundtableID === 'a1f7390a-de1a-44a9-a8cf-370782a147f8') {
              this.summary = response.data.d3information.filter(
                (info) => info.users_I_have_commented_to.length !== 0
              );
            } else {
              this.summary = response.data.d3information;
            }
            this.loading_chord = false;
            this.loading_page = false;
          })
          .catch(console.error);
      }
    },
  });
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .position-info-button
    margin-right: -30px;
  .empty-message-size
    width: 400px;
    height: 400px;
  .social-icons
    height: 25px
    margin: 0px 10px
</style>



// WEBPACK FOOTER //
// CommentChord.vue?7dcdae28